import { useQuery } from "@tanstack/react-query";

import { customFetch } from "../util/customFetch";

export function useGeneratePublicProcessLink({ enabled = true }) {
  return useQuery({
    enabled,
    queryKey: ["generate-process-link"],
    queryFn: async () =>
      customFetch(`/api/smartbpm/v1/process-definitions/generate-start-link`),
  });
}
